/**
 *  Scroll To Content Button
 */
export default function() {
	let scrollDown  = document.getElementById('scroll-down')
	let pageWrapper = document.getElementById('content')

	if (scrollDown !== null && pageWrapper !== null) {
		scrollDown.addEventListener('click', (ev) => {
			ev.preventDefault()
			let offset = document.getElementById('wrapper-navbar')
			let HeaderHeight = (typeof offset.dataset.scrolledHeight !== 'undefined' ) ? offset.dataset.scrolledHeight :  offset.offsetHeight
			window.scrollTo({
				top: pageWrapper.offsetTop - HeaderHeight,
				behavior: "smooth"
			})
		});
	}
};
